var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.creditCodeValue > 0)?_c('Transition',{attrs:{"name":"ease-in-out"}},[_c('div',{class:_vm.$style.creditCode},[_c('div',{staticClass:"container"},[_c('div',{class:_vm.$style.message},[_c('h5',[_vm._v("Congratulations! Your £"+_vm._s(_vm.creditCodeValue)+" discount will be applied at checkout")])])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }